import { Typography, Stack, Chip, Checkbox } from '@mui/material_modern'
import DataGridWithSearchV2 from 'components/generic/datagrid/DataGridWithSearchV2'

const getColumns = () => [
  {
    field: 'name',
    headerName: 'Location Name',
    flex: 5,
    renderCell: ({ row }) => {
      return (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{
            overflowX: 'scroll',
            '-ms-overflow-style': 'none',
            'scrollbar-width': 'none',
          }}
        >
          <Typography variant="body2">{row.name}</Typography>
          {row.isDefaultCorporateLocation && <Chip label="Default Corporate" />}
          {row.isDefaultShippingLocation && <Chip label="Default Shipping" />}
          {row.isDefaultPayToLocation && <Chip label="Default Pay-To" />}
        </Stack>
      )
    },
  },
  {
    field: 'fullAddress',
    headerName: 'Address',
    flex: 3,
  },
  {
    field: 'isCorporate',
    headerName: 'Corporate',
    flex: 1,
    renderCell: params => {
      return <Checkbox checked={params.row.isCorporate} disabled />
    },
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'isShipping',
    headerName: 'Shipping',
    flex: 1,
    renderCell: params => {
      return <Checkbox checked={params.row.isShipping} disabled />
    },
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'isPayToLocation',
    headerName: 'Pay-To',
    flex: 1,
    renderCell: params => {
      return <Checkbox checked={params.row.isPayToLocation} disabled />
    },
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'primaryContactName',
    headerName: 'Primary Contact',
    flex: 2,
  },
  {
    field: 'notes',
    headerName: 'Notes',
    flex: 2,
  },
]

const VehicleGrid = ({ rows }) => {
  return (
    <DataGridWithSearchV2 rows={rows} columns={getColumns()} disableSelectionOnClick hideFooter disableColumnMenu />
  )
}

VehicleGrid.propTypes = DataGridWithSearchV2.propTypes

VehicleGrid.defaultProps = DataGridWithSearchV2.defaultProps

export default VehicleGrid
